import React from 'react'

import Icon from 'components/Icon'
import Tooltip from 'components/Tooltip'

import classes from './InfoCircleTooltip.module.scss'

/** @type {import("./types").default} */
const InfoCircleTooltip = ({ className, label, ...props }) => (
  <Tooltip enterTouchDelay={50} {...props}>
    <span className={className}>
      {label && label}
      <div className={classes.infoCircleContainer}>
        <Icon prefix="far" icon="circle-info" size="16" />
      </div>
    </span>
  </Tooltip>
)

export default InfoCircleTooltip
